import router from './router'

// MU-20 PR 11: o módulo virou só rota — as views/layouts Vue morreram no PR
// 8c (a tela é a ilha React em react-apps/convenios) e a store/api que as
// servia saiu junto com o resto do código morto.
export default {
  router
}
